import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, clearTimeOut } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Detail = Loadable({
    loader: () => import('./Detail'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          utilityTransactionDetailState: state.utilityTransactionDetailState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          clearTimeOut,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/detail/:orderNo`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Detail {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
